import {
    Imports,
    IEditorViewMode,
    IEditorViewState,
    IEditorToolbarSize,
    IEditorHandleLayout,
    IEditorProductType,
    IEditorType, IEditorThumbSize, IEditorThumb, IEditorImage, IThumbDictionary, IEditorPhoto, IEditorGraphicAsset,
    IEditorEdge, IEditorLayout, IEditorTemplate, IEditorElement, IEditorElementCollection, IEditorPage,
    IEditorImagePosition, IRepeatedImagePatternOptions, IEditorShapeAsset, IEditorTextElement, IRootStyle, ITextEdits,
    IEditorImageElement, IEditorClipartElement, IEditorGroupElement, IEditorFullPageElement, IEditorBackgroundElement,
    IEditorForegroundElement, IEditorPhotoElement, IEditorFrame, IEditorObservable, IEditorElementError, IEditorProject,
    IEditorPageGroup, IEditorShape, IEditorProjectPhotos, IEditorSettings, IEditorProduct, IPreviewThumb,
    EditorMaskOverlay, MaskOverlayImage, EditorNonPrintableBackground, IEditorFont, IEditorOpenedFont, IFontData,
    IEditorCommands
} from "./editor.interfaces";
import {fabric} from "fabric";



const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

export enum ThreeDOption {
    Full = 0,
    MinimizedThenFull = 1,
    MinimizedOnly = 2,  // TODO: Impliment minimizedOnly..
    AlwaysMinimized = 3,
    None = 4
}

/*
 * This file contains all the models for edits
 */

// tslint:disable:variable-name
const ProductAttribute = {
    MIN_PAGES: 'min_pages',
    MAX_PAGES: 'max_pages',
    COST_PER_PAGE: 'cost_per_page',
    PAGE_IMPOSITION: 'page_imposition',
    PAPER_TYPE: 'paper_type',
    SERVICE_LEVEL: 'service_level',
    WRAP: 'wrap',
    WRAP_EDGE_STYLE: 'wrap_edge_style',
    NUM_FLY_PAGES: 'number_of_fly_pages',
    ROTATABLE: 'rotatable',

    // Merge pages
    PAGES: 'pages',
    MERGE_PAGES: 'merge_pages',

    // cover
    COVER_COLOR: 'cover_color',
    COVER_MATERIAL: 'cover_material',
    COVER_STYLE: 'cover_style',
    COVER_TYPE: 'cover_type',
    COVER_PHOTO: 'cover_photo',
    COVER_WIDTH: 'cover_width',
    COVER_HEIGHT: 'cover_height',

    // spine
    SPINE_WIDTH: 'spine_width',
    SPINE_EXTRA_PAGE_THRESHOLD: 'spine_extra_page_threshold',
    SPINE_EXTRA_PAGE_SIZE: 'spine_extra_page_size',

    // the following two are for being future proof, but so far we are only using NUM_FLY_PAGES
    NUM_FLY_PAGES_BEGINNING: 'fly_pages_beginning',
    NUM_FLY_PAGES_END: 'fly_pages_end',

    // side bleed
    BLEED_SIDE_LEFT: 'bleed_side_l',
    BLEED_SIDE_TOP: 'bleed_side_t',
    BLEED_SIDE_RIGHT: 'bleed_side_r',
    BLEED_SIDE_BOTTOM: 'bleed_side_b',

    // back bleed
    BLEED_BACK_LEFT: 'bleed_back_l',
    BLEED_BACK_TOP: 'bleed_back_t',
    BLEED_BACK_RIGHT: 'bleed_back_r',
    BLEED_BACK_BOTTOM: 'bleed_back_b',

    // safety bleed
    BLEED_SAFETY_TOP: 'bleed_safety_t',
    BLEED_SAFETY_RIGHT: 'bleed_safety_r',
    BLEED_SAFETY_BOTTOM: 'bleed_safety_b',
    BLEED_SAFETY_LEFT: 'bleed_safety_l',

    // wrap options
    WRAP_OPTIONS: 'wrap_options',

    // optimal size
    OPTIMAL_WIDTH: 'optimal_x',
    OPTIMAL_HEIGHT: 'optimal_y',
    OPTIMAL_DPI: 'optimal_d',
    WARNING_DPI: 'warning_d',
    MINIMUM_DPI: 'minimum_d',

    // keyhole
    KEYHOLE_POSITION_L: 'keyhole_position_l',
    KEYHOLE_POSITION_T: 'keyhole_position_t',
    KEYHOLE_SIZE_H: 'keyhole_size_h',
    KEYHOLE_SIZE_W: 'keyhole_size_w',
    HAS_KEYHOLE: 'has_keyhole',
    KEYHOLE: 'keyhole'
};

const EditorBleedProperties = {
    // side bleed
    BLEED_SIDE_LEFT: 'leftSideDepth',
    BLEED_SIDE_TOP: 'topSideDepth',
    BLEED_SIDE_RIGHT: 'rightSideDepth',
    BLEED_SIDE_BOTTOM: 'bottomSideDepth',

    // back bleed
    BLEED_BACK_LEFT: 'leftBackOverPrint',
    BLEED_BACK_TOP: 'topBackOverPrint',
    BLEED_BACK_RIGHT: 'rightBackOverPrint',
    BLEED_BACK_BOTTOM: 'bottomBackOverPrint',
}

const CoverPhotoMarginAttribute = {
    COVER_PHOTO_MARGIN_RIGHT: 'coverPhotoMarginRight',
    COVER_PHOTO_MARGIN_LEFT: 'coverPhotoMarginLeft',
    COVER_PHOTO_MARGIN_BOTTOM: 'coverPhotoMarginBottom',
    COVER_PHOTO_MARGIN_TOP: 'coverPhotoMarginTop',
};

const ViewMode:IEditorViewMode = {
    SINGLE: 'single_page',
    GROUP: 'group'
};

const ViewState:IEditorViewState = {
    MULTI_PAGE_PRODUCT: 'multi_image',
    SINGLE_PAGE_PRODUCT: 'single_image',
    SINGLE_PAGE_MULTI_ZONE_PRODUCT: 'single_page_multi_zone'
};

const ToolbarSize:IEditorToolbarSize = {
    LARGE: 'large',
    SMALL: 'small'
};

const HandleLayout : IEditorHandleLayout = {
    DEFAULT: 'default',
    MOBILE: 'mobile'
};

export const ProductType:IEditorProductType = {
    ED_GENERIC: 'generic',
    ED_ARCHIVE_PRODUCT: 'archive',
    ED_PASSPORT_PHOTO: 'passport',
    ED_12P_CALENDAR: '12p_calendar',
    ED_CALENDAR: 'calendar',
    ED_CANVAS: 'canvas',
    ED_CANVAS_EDITOR: 'canvas_editor',
    ED_COLLAGE_PRINT: 'collage_print',
    ED_DESIGN_PRINT: 'design_print',
    ED_GIFT_TAGS: 'gift_tags',
    ED_GREETING_CARD: 'greeting_card',
    ED_FOLDED_CARD: 'folded_card',
    ED_PHOTO_BOOK: 'photo_book',
    ED_FLIP_BOOK: 'flip_book',
    ED_PHOTO_GIFT: 'photo_gift',
    ED_PICTURE_PACK: 'picture_pack',
    ED_PASSPORT_PICTURE_PACK: 'passport_picture_pack',
    ED_PRINT: 'print',
    ED_SINGLE_IMAGE_TEMPLATE: 'single_image_template',
    ED_MULTI_IMAGE: 'multiple_image',
    ED_TEMPLATE_CANVAS: 'template_canvas',
    ED_PREFILL_TEMPLATE: 'prefill_template',
    ED_SMART_CALENDAR: 'smart_calendar',
    ED_MULTIPLE_PAGE_MERGE: 'multiple_page_merge',
    ED_MULTIPLE_PAGE_MERGE_TEMPLATE: 'multiple_page_merge_template',
    ED_MULTIPLE_IMAGE: 'multiple_image',
    ED_MULTIPLE_PAGE_TEMPLATE: 'multiple_page',
    ED_TEMPLATE_GIFT: 'template_gift',
    ED_TWO_PAGE_TEMPLATE_GIFT: 'two_page_template_gift',
};

const TemplatedProductTypes: string[] = [
    ProductType.ED_12P_CALENDAR,
    ProductType.ED_SMART_CALENDAR,
    ProductType.ED_CALENDAR,
    ProductType.ED_COLLAGE_PRINT,
    ProductType.ED_DESIGN_PRINT,
    ProductType.ED_FOLDED_CARD,
    ProductType.ED_FLIP_BOOK,
    ProductType.ED_GIFT_TAGS,
    ProductType.ED_GREETING_CARD,
    ProductType.ED_MULTIPLE_PAGE_MERGE_TEMPLATE,
    ProductType.ED_MULTIPLE_IMAGE,
    ProductType.ED_MULTIPLE_PAGE_TEMPLATE,
    ProductType.ED_PHOTO_BOOK,
    ProductType.ED_PICTURE_PACK,
    ProductType.ED_PASSPORT_PICTURE_PACK,
    ProductType.ED_PREFILL_TEMPLATE,
    ProductType.ED_SINGLE_IMAGE_TEMPLATE,
    ProductType.ED_TEMPLATE_CANVAS,
    ProductType.ED_TEMPLATE_GIFT,
    ProductType.ED_TWO_PAGE_TEMPLATE_GIFT,
];

const EditorType:IEditorType = {
    ES_PRINT: 'print',
    ES_SINGLE_PAGE: 'single_page_template',
    ES_FRONT_BACK_TEMPLATE: 'front_back_template',
    ES_MULTI_PAGE: 'multipage_template',
    ES_FACING_PAGES: 'facing_page_template',
    ES_MULTI_PAGE_NO_TEMPLATE: 'multipage_no_template'
};

const Commands:IEditorCommands = {
    SAVE_PROJECT: 'saveProject',
    ADD_TO_CART: 'addToCart',
    SAVE_AS_ORDER: 'saveAsOrder',
    GO_TO_MY_PROJECTS: 'goToMyProjects',
    GO_TO_PAGE: 'goToPage',
    GO_TO_GROUP: 'goToGroup',
    GO_TO_GROUP_PROJECT_PAGE: 'goToGroupProjectPage',
    HIDE_THREED_PREVIEW: 'hide3DPreview',
    UPDATE_PAGER: 'updatePager',
    PIN_PAGER: 'pinPager',
    ADD_TEXT: 'addText',
    EXIT_TEXT_EDITING: 'exitEditing',
    UN_PIN_PAGER: 'unPinPager',
    SET_VIEW_MODE: 'setViewMode',
    SET_DESIGN_MODE: 'setDesignMode',
    SET_EDITS: 'setEdits',
    RESIZE_PAGE: 'resizePage',
    GET_EDITS: 'board.getEdits',
    PREVIEW: 'preview',
    RELOAD_EDITS: 'reloadEdits',
    CHANGE_ORIENTATION: 'changeOrientation',
    SAVE_TEMPLATE: 'saveTemplate',
    OPEN_EDITS_MODAL: 'openEditModal',
    RENDER_PREVIEW: 'renderPreview',
    LOAD_PROJECT: 'loadProject',
    GET_PROJECT: 'setProjectId',

    TOGGLE_HANDLE_LAYOUT: 'toggleHandleLayout',

    AUTO_POPULATE_PHOTOS: 'autoPopulatePhotos',
    SHUFFLE_PHOTOS: 'shufflePhotos',

    // clipboard
    COPY: 'copy',
    PASTE: 'paste',
    CUT: 'cut',

    // undo
    UNDO_MANAGER_UNDO: 'undoManager.undo',
    UNDO_MANAGER_REDO: 'undoManager.redo',
    UNDO_MANAGER_ADD: 'undoManager.add',
    UNDO_MANAGER_PROCESSED: 'undoManager.processed',
    UNDO_MANAGER_CLEAR: 'undoManager.clear',
    UNDO_MANAGER_BATCH: 'undoManager.batch',
    UNDO_MANAGER_BATCH_START: 'undoManager.batchStart',
    UNDO_MANAGER_BATCH_STOP: 'undoManager.batchStop',
    UNDO_MANAGER_ADD_PROJECT_PREVIEW_DATA: 'undoManager.addProjectPreviewData',

    // interaction with board
    BOARD_ADD: 'board.add',
    BOARD_REMOVE: 'board.remove',
    BOARD_RENDER: 'board.render',
    BOARD_SET_SELECTED_OBJECT: 'board.setSelectedObject',
    BOARD_GET_SELECTED_OBJECT: 'board.getSelectedObject',
    BOARD_GET_ACTIVE_GROUP: 'board.getActiveGroup',
    BOARD_GET_ACTIVE_OBJECT: 'board.getActiveObject',
    BOARD_GET_ZOOM: 'board.getZoom',
    BOARD_RESIZE: 'board.resize',

    // interaction with pager
    PAGER_REPLACE_PAGE: 'pager.replacePage',

    // interaction with gallery
    GALLERY_SET_PANEL_VISIBILITY: 'gallery.setPanelVisibility',

    // loading indicator
    LOADING: 'loading',
    LOADING_SHOW: 'loading.show',
    LOADING_HIDE: 'loading.hide',

    // toolbar
    TOOLBAR_RESIZE: 'toolbar.resize',
    TOOLBAR_REPOSITION: 'toolbar.reposition'
};

const Masks = {
    rectangle: 'M 0.0 0.0 L 20.0 0.0 L 20.0 20.0 L 0.0 20.0 L 0.0 0.0 Z',
    ellipse: 'M 0 19.67 C 0 8.8 8.81 0 19.68 0 C 30.54 0 39.35 8.8 39.35 19.67 C 39.35 30.53 30.54 39.33 19.68 39.33 C 8.81 39.33 0 30.53 0 19.67 Z',
    bubble_speech: 'M 0.031 10.402 C -0.349 14.562 2.861 18.522 8.031 21.082 C 6.932 23.632 4.941 25.492 4.941 25.492 C 6.582 25.972 9.622 24.252 11.982 22.642 C 14.022 23.262 16.242 23.692 18.591 23.882 C 29.442 24.772 38.722 20.172 39.321 13.602 C 39.932 7.042 31.622 1.002 20.772 0.112 C 9.921 -0.768 0.631 3.832 0.031 10.402 Z',
    flag: 'M 0 2.183 L 0 27.323 C 0 27.323 11.18 18.943 19.32 26.683 C 27.47 34.413 39 26.683 39 26.683 L 39 1.543 C 39 1.543 31.03 7.183 20.51 2.183 C 9.99 -2.807 0 2.183 0 2.183 Z',
    heart: 'M 19.365 7.733 C 19.055 6.573 17.055 0.313 9.915 0.013 C 2.044 -0.317 0.165 6.833 0.165 6.833 C 0.165 6.833 -1.396 14.213 5.814 20.783 C 12.685 28.593 16.475 32.743 19.265 37.043 L 19.274 37.103 C 19.305 37.293 19.334 37.383 19.365 37.363 C 19.404 37.383 19.435 37.293 19.464 37.113 L 19.475 37.043 C 22.384 33.093 26.644 28.353 32.924 20.783 C 40.134 14.213 38.575 6.833 38.575 6.833 C 38.575 6.833 36.694 -0.317 28.825 0.013 C 21.754 0.313 19.705 6.473 19.365 7.733 Z',
    heart_puff: 'M 19.622 3.467 C 17.692 2.036 13.962 -0.303 10.702 0.036 C 5.902 0.197 4.152 1.846 4.152 1.846 C 4.152 1.846 -4.608 6.616 3.162 19.087 C 10.372 28.337 19.462 31.417 19.622 31.467 C 19.783 31.417 28.882 28.337 36.092 19.087 C 43.852 6.616 35.102 1.846 35.102 1.846 C 35.102 1.846 33.342 0.197 28.542 0.036 C 25.283 -0.303 21.562 2.036 19.622 3.467 Z',
    heart_tapered: 'M 19.365 7.733 C 19.054 6.573 17.054 0.313 9.914 0.013 C 2.045 -0.317 0.164 6.833 0.164 6.833 C 0.164 6.833 -1.395 14.223 5.815 20.783 C 13.034 27.353 18.525 33.103 19.264 37.043 L 19.275 37.103 C 19.304 37.293 19.335 37.383 19.365 37.363 C 19.405 37.383 19.434 37.293 19.454 37.113 L 19.474 37.043 C 20.215 33.103 25.704 27.353 32.914 20.783 C 40.135 14.223 38.575 6.833 38.575 6.833 C 38.575 6.833 36.695 -0.317 28.825 0.013 C 21.755 0.313 19.704 6.473 19.365 7.733 Z',
    teardrop: 'M 0 25.38 C 0 17.68 8.32 12.79 13.78 0 C 17.13 11.43 27.55 17.68 27.55 25.38 C 27.55 33.09 21.38 39.33 13.78 39.33 C 6.17 39.33 0 33.09 0 25.38 Z',
    cloud_7: 'M 6.64 9.6 C 6.64 9.94 6.66 10.28 6.71 10.61 C 2.94 11.01 0 14.11 0 17.87 C 0 21.47 2.68 24.46 6.22 25.07 C 6.18 25.36 6.16 25.66 6.16 25.96 C 6.16 29.99 9.54 33.26 13.7 33.26 C 15.69 33.26 17.5 32.52 18.84 31.3 C 20.23 32.95 22.34 34 24.7 34 C 27.95 34 30.72 32 31.78 29.2 C 32.61 29.51 33.52 29.68 34.46 29.68 C 38.63 29.68 42 26.41 42 22.38 C 42 20.31 41.11 18.44 39.69 17.11 C 40.43 15.98 40.86 14.63 40.86 13.19 C 40.86 9.15 37.49 5.88 33.33 5.88 C 32.88 5.88 32.44 5.92 32.02 5.99 C 31.38 2.58 28.3 0 24.6 0 C 21.91 0 19.54 1.37 18.21 3.43 C 17.04 2.71 15.66 2.3 14.17 2.3 C 10.01 2.3 6.64 5.57 6.64 9.6 Z',
    cloud_6: 'M 6.05 7.19 C 6.05 8.5 6.4 9.73 7.02 10.79 C 3.12 10.91 0 14.08 0 17.97 C 0 21.68 2.83 24.73 6.48 25.12 C 6.2 25.88 6.05 26.7 6.05 27.55 C 6.05 31.52 9.3 34.74 13.32 34.74 C 15.84 34.74 18.07 33.47 19.37 31.53 C 20.67 33.47 22.9 34.74 25.42 34.74 C 29.44 34.74 32.69 31.52 32.69 27.55 C 32.69 26.71 32.54 25.91 32.27 25.16 C 36.2 25.06 39.35 21.88 39.35 17.97 C 39.35 14 36.1 10.78 32.08 10.78 L 31.71 10.79 C 32.33 9.73 32.69 8.5 32.69 7.19 C 32.69 3.22 29.44 0 25.42 0 C 22.9 0 20.67 1.28 19.37 3.21 C 18.07 1.28 15.84 0 13.32 0 C 9.3 0 6.05 3.22 6.05 7.19 Z',
    clover: 'M 6.352 6.351 C 5.772 5.991 4.092 5.761 1.392 8.221 C -1.588 10.941 1.082 14.951 1.082 14.951 C 1.082 14.951 2.172 16.941 5.682 17.991 C 2.132 19.181 1.382 20.861 1.382 20.861 C 1.382 20.861 -1.278 24.891 1.702 27.591 C 4.382 30.011 6.032 29.831 6.672 29.431 C 6.312 30.021 6.072 31.691 8.532 34.381 C 11.242 37.331 15.252 34.661 15.252 34.661 C 15.252 34.661 17.052 33.651 18.142 30.521 C 19.212 33.871 21.132 34.911 21.132 34.911 C 21.132 34.911 25.132 37.541 27.822 34.561 C 30.262 31.851 30.022 30.191 29.662 29.611 C 30.302 29.991 31.942 30.161 34.592 27.731 C 37.532 25.021 34.892 21.031 34.892 21.031 C 34.892 21.031 34.112 19.271 30.342 18.111 C 33.592 17.021 34.612 15.151 34.612 15.151 C 34.612 15.151 37.252 11.141 34.292 8.451 C 31.622 6.011 29.952 6.241 29.382 6.601 C 29.762 5.971 29.932 4.321 27.522 1.661 C 24.822 -1.299 20.832 1.351 20.832 1.351 C 20.832 1.351 19.092 2.131 17.932 5.831 C 16.752 1.881 14.932 1.071 14.932 1.071 C 14.932 1.071 10.912 -1.579 8.212 1.391 C 5.782 4.061 5.962 5.711 6.352 6.351 Z',
    splat: 'M 16.765 7.252 C 16.765 7.252 17.485 10.092 16.765 10.762 C 16.035 11.432 12.794 9.672 11.625 8.422 C 10.005 6.682 8.925 7.582 8.645 8.752 C 8.375 9.922 13.965 11.432 15.314 14.022 C 16.675 16.612 12.075 15.532 12.075 15.532 C 12.075 15.532 6.395 15.192 9.465 18.042 C 12.524 20.882 7.115 21.982 5.855 22.892 C 4.235 24.062 1.445 23.642 0.265 25.572 C -0.905 27.492 2.255 27.152 4.325 25.822 C 6.395 24.482 11.535 23.392 13.425 24.062 C 15.314 24.732 11.625 26.902 10.635 26.822 C 9.645 26.742 8.465 27.912 9.195 29.162 C 9.915 30.422 11.715 28.912 12.615 27.992 C 13.515 27.072 15.675 26.652 16.495 27.992 C 16.945 28.742 14.235 31.502 14.235 31.502 C 14.235 31.502 10.455 35.852 12.705 37.112 C 14.814 38.282 16.035 33.092 16.765 31.422 C 17.485 29.752 18.965 29.292 19.735 30.002 C 21.175 31.342 19.735 34.682 19.375 36.442 C 19.064 37.952 20.725 39.452 21.805 39.952 C 22.885 40.462 23.515 36.782 22.615 32.932 C 21.755 29.252 24.334 30.502 26.225 30.332 C 27.935 30.182 30.005 36.112 30.005 36.112 C 30.005 36.112 31.544 37.532 32.985 36.362 C 34.425 35.192 28.294 28.742 28.294 28.742 C 28.294 28.742 27.084 26.902 28.655 26.992 C 31.814 27.152 36.854 29.922 36.854 29.922 C 36.854 29.922 39.564 30.582 37.845 28.582 C 37.195 27.812 30.814 24.062 30.095 22.052 C 29.375 20.042 36.314 21.632 36.314 21.632 C 36.314 21.632 38.405 21.892 39.745 19.962 C 41.365 17.622 35.235 18.872 35.235 18.872 C 35.235 18.872 31.455 20.212 30.365 17.452 C 29.285 14.692 35.834 9.892 37.575 9.502 C 39.475 9.092 39.655 7.912 39.655 7.912 C 39.655 7.912 37.584 5.342 36.135 7.162 C 34.604 9.092 30.095 13.022 28.475 13.522 C 26.854 14.022 29.555 6.412 26.854 8.172 C 25.955 9.092 25.955 10.932 24.695 13.022 C 23.425 15.112 21.985 12.602 20.905 11.512 C 19.825 10.422 21.265 3.562 19.645 0.552 C 19.285 -0.118 17.215 -0.528 15.765 1.472 C 14.535 3.192 16.765 7.252 16.765 7.252 Z M 4.865 12.852 C 4.865 12.852 4.235 11.852 2.615 12.432 C 1.165 14.102 1.805 14.862 3.064 14.942 C 4.325 15.022 5.135 15.612 6.575 15.862 C 8.015 16.032 8.835 15.862 8.645 14.942 C 8.465 14.022 6.215 14.022 4.865 12.852 Z M 28.985 3.442 C 28.985 3.442 30.665 2.672 30.115 1.122 C 27.725 0.172 26.995 1.652 26.845 2.832 C 26.055 3.892 26.945 4.272 26.595 5.602 C 26.334 6.942 26.505 7.122 27.515 7.002 C 28.515 6.872 27.645 4.642 28.985 3.442 Z',
    arrow: 'M 0 12.18 L 15 12.18 L 15 0 L 35.35 19.67 L 15 39.33 L 15 28.18 L 0 28.18 L 0 12.18 Z',
    star_5: 'M 19.67 0 L 25.75 12.08 L 39.35 14.02 L 29.51 23.43 L 31.83 36.71 L 19.67 30.44 L 7.51 36.71 L 9.83 23.43 L 0 14.02 L 13.59 12.08 L 19.67 0 Z',
    star_6: 'M 16.73 0 L 21.56 10.97 L 33.45 9.67 L 26.39 19.34 L 33.45 29.01 L 21.56 27.71 L 16.73 38.68 L 11.9 27.71 L 0 29.01 L 7.07 19.34 L 0 9.67 L 11.9 10.97 L 16.73 0 Z',
    star_33_fat: 'M 20 0 L 21.23 7.2 L 23.79 0.36 L 23.63 7.66 L 27.44 1.44 L 25.91 8.57 L 30.83 3.18 L 27.97 9.9 L 33.82 5.54 L 29.74 11.59 L 36.31 8.42 L 31.16 13.59 L 38.21 11.72 L 32.18 15.82 L 39.46 15.32 L 32.76 18.21 L 40 19.09 L 32.88 20.66 L 39.82 22.9 L 32.53 23.09 L 38.92 26.6 L 31.73 25.41 L 37.34 30.07 L 30.5 27.53 L 35.13 33.17 L 28.9 29.39 L 32.38 35.8 L 26.97 30.9 L 29.17 37.86 L 24.79 32.03 L 25.64 39.28 L 22.44 32.72 L 21.9 40 L 20 32.95 L 18.1 40 L 17.56 32.72 L 14.36 39.28 L 15.21 32.03 L 10.83 37.86 L 13.03 30.9 L 7.62 35.8 L 11.1 29.39 L 4.87 33.17 L 9.5 27.53 L 2.66 30.07 L 8.27 25.41 L 1.08 26.6 L 7.47 23.09 L 0.18 22.9 L 7.12 20.66 L 0 19.09 L 7.24 18.21 L 0.54 15.32 L 7.82 15.82 L 1.79 11.72 L 8.84 13.59 L 3.69 8.42 L 10.26 11.59 L 6.18 5.54 L 12.03 9.9 L 9.17 3.18 L 14.09 8.57 L 12.56 1.44 L 16.37 7.66 L 16.21 0.36 L 18.77 7.2 L 20 0 Z'
};

const EditorWrapOptions = {
    EDGE_STYLE: 'edgeStyle',
    EDGE_COLOR: 'edgeColor',
    CORNER_TYPE: 'cornerType',
    BACK_PRESENTATION: 'backPresentation'
}

const EdgeStyles = {
    IMAGE_WRAP: 'image_wrap',
    MIRROR_WRAP: 'mirror_wrap',
    BORDER: 'border',
    BORDER_WHITE: 'border_white',
    EXTEND: 'extend',
    IMAGE_WRAP_WITH_BLUR: 'image_wrap_with_blur',
    MIRROR_WRAP_WITH_BLUR: 'mirror_wrap_with_blur'
};

export const ShapeAssetTypes = {
    Triangle: 'triangle',
    Rectangle: 'rect',
    Circle: 'circle',
    Star: 'polygon',
    SpeechBubble: 'path',
};

const CornerTypes = {
    DIAGONAL_FOLD: 'diagonal_fold',
    HORIZONTAL_FOLD: 'horizontal_fold',
    VERTICAL_FOLD: 'vertical_fold',
    NO_FOLD: 'no_fold'
};

const GalleryPanels = {
    PHOTOS: 'photos',
    BACKGROUNDS: 'backgrounds',
    TEMPLATES: 'templates',
    LAYOUTS: 'layouts',
    EDGES: 'edges',
    CLIP_ART: 'clip_art',
    SHAPES: 'shapes'
};

const ElementErrorType = {
    MISSING_PHOTO: 1,
    RESOLUTION: 2,
    TEXT: 3
};

const THREED_PREVIEW_COLOR = {
    DARK: 'dark',
    LIGHT: 'light',
    WHITE_MUG: 'white_mug'
};

// enums
export const ThumbSize: IEditorThumbSize = {
    FULL: 'full',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',

    mapFromPhp: function (thumbType: string): string {

        switch (thumbType) {
            case 'CI_SIZE_XXLARGE':
                // tslint:disable-next-line:no-invalid-this
                return this.XLARGE;
            case 'CI_SIZE_XLARGE':
                // tslint:disable-next-line:no-invalid-this
                return this.LARGE;
            case 'CI_SIZE_LARGE':
                // tslint:disable-next-line:no-invalid-this
                return this.MEDIUM;
            case 'CI_SIZE_MEDIUM':
                // tslint:disable-next-line:no-invalid-this
                return this.SMALL;
            default:
                // tslint:disable-next-line:no-invalid-this
                return this.FULL;
        }

    }
};

// thumb data holder
class Thumb implements IEditorThumb {
    constructor(public name: string, public width: number, public height: number) {

    }
}

// image data holder
class Image extends Thumb implements IEditorImage {
    public pathPrefix: string = '';
    public edits: { rotation?: number, autocorrect?: boolean } = {};

    constructor(public id: number|null, public urlPrefix: string = '', public thumbs: IThumbDictionary = {}) {
        super('', 0, 0);
        if (thumbs && thumbs[ThumbSize.FULL]) {
            const thumb = thumbs[ThumbSize.FULL];
            this.name = thumb.name;
            this.width = thumb.width;
            this.height = thumb.height;
        }
    }

    /**
     * @param {string} size
     * @return {SF.Model.Thumb}
     */
    public getThumb(size: string): IEditorThumb {
        return this.thumbs[size];
    }

    /**
     * @param {string} name
     * @param {boolean} [hasAutoCorrect]
     * @param {boolean} [hasAutoRedEye]
     * @returns {string}
     */
    public getUrl(name: string, hasAutoCorrect?: boolean, hasAutoRedEye?: boolean): string {
        let extension = '';
        if (hasAutoRedEye && hasAutoCorrect) {
            extension = '.ar';
        } else if (hasAutoRedEye) {
            extension = '.r';
        } else if (hasAutoCorrect) {
            extension = '.a';
        }
        return this.urlPrefix + name + extension;
    }
}

class Photo extends Image implements IEditorPhoto {

    public pathPrefix: string = '';

    constructor(public id: number, public urlPrefix: string, public thumbs: IThumbDictionary, public imageData: any = null, public edits: any = {}) {
        super(id, urlPrefix, thumbs);
    }

    public getBestCropRectangle(width: number, height: number): number[]|null {
        // TODO: use smartcrop (https://raw.githubusercontent.com/jwagner/smartcrop.js/master/smartcrop.js) to do a better job
        return null;
    }
}

class GraphicAsset extends Image implements IEditorGraphicAsset {

    /**
     * Type can be: ['background', 'clipart', 'photo', 'edge']
     *
     * @param id
     * @param type
     * @param urlPrefix
     * @param thumbs
     */
    constructor(public id: number, public type: string, public  urlPrefix: string, public  thumbs: IThumbDictionary) {
        super(id, urlPrefix, thumbs);
    }
}

class Edge extends GraphicAsset implements IEditorEdge {
    /**
     * @param id
     * @param urlPrefix
     * @param thumbs
     * @param marginTop
     * @param marginRight
     * @param marginBottom
     * @param marginLeft
     */
    constructor(public id: number, public urlPrefix: string, public  thumbs: IThumbDictionary, public  marginTop: number,
                public marginRight: number, public  marginBottom: number, public  marginLeft: number) {
        super(id, 'edge', urlPrefix, thumbs);
    }
}

class Layout implements IEditorLayout {
    // TODO: Fix any in frames and data...

    constructor(public id: number, public  categoryId: number, public  frames: number, public data: any) {

    }
}

class Template implements IEditorTemplate {
    constructor(public  id: string, public categoryId: string, public width: number, public height: number, public elements: null | IEditorElement[] = null) {

    }
}

function isInteger(value: any): boolean {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
}

class ElementCollection implements IEditorElementCollection {
    public width: number;
    public height: number;
    // noinspection JSMismatchedCollectionQueryUpdate - this is a false positive by Intellij, this is used in a ton of places...
    public visiblePages: IEditorPage[] = [];
    public elements: IEditorElement[] = [];

    constructor(public pages: IEditorPage[], showingIndex?: number) {
        showingIndex = isInteger(showingIndex) ? showingIndex : undefined;
        this.width = 0;
        this.height = 0;

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];

            this.height = Math.max(page.height, this.height);
            if (showingIndex === undefined || showingIndex == page.index) {
                this.width += page.width;
                this.visiblePages.push(page);
            }

            this.elements = this.elements.concat(page.elements);
        }
    }
}

// Edits Objects
// Currently not used, but a starting point for the future.
// the base element
class Element implements IEditorElement {
    public x: number = 0;
    public y: number = 0;
    public width: number = 0;
    public height: number = 0;
    public effects: any = {};
    public rotation: number = 0;
    public opacity: number = 1;

    public editableSave?: boolean = undefined;
    public editable: boolean = true;
    public locked: boolean = false;
    public fixed: boolean = false;
    //@note this is currently only used on the background. Consider moving it there
    public isLetterBoxed: boolean = false;
    public order: number = 0;
    public uid: string;
    public uniquePhotoId!: number;
    public imagePosition!: IEditorImagePosition;
    public pattern?: IRepeatedImagePatternOptions;

    constructor() {
        this.uid = this.generateUid();

        // data that is just passed through for flash

    }

    public generateUid(): string {
        return SF.Util.Translator.generateUid();
    }

    public _clone(e: IEditorElement): void {
        e.uid = this.uid;
        e.x = this.x;
        e.y = this.y;
        e.width = this.width;
        e.height = this.height;
        e.effects = fabric.util.object.clone(this.effects);
        e.rotation = this.rotation;
        e.opacity = this.opacity;
        e.editable = this.editable;
        e.locked = this.locked;
        e.fixed = this.fixed;
        e.editableSave = this.editableSave;
        e.isLetterBoxed = this.isLetterBoxed;
        e.pattern = this.pattern;
        if (this.uniquePhotoId) {
            (e as any).uniquePhotoId = this.uniquePhotoId;
        }
        const extraPropertiesToInclude = SF.Util.Translator.extraPropertiesToInclude;
        if(extraPropertiesToInclude) {
            extraPropertiesToInclude.forEach((extraPropertyToInclude: string) => {
                // @ts-ignore
                if (this[extraPropertyToInclude] !== undefined) {
                    Object.defineProperty(e, extraPropertyToInclude, {
                        // @ts-ignore
                        value: this[extraPropertyToInclude],
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                }
            });
        }

    }
}

// a shape asset
class ShapeAsset extends Element implements IEditorShapeAsset {
    public flipX:boolean = false;
    public flipY:boolean = false;

    constructor(public jsonData: any) {
        super();
    }
}

// a text element
class TextElement extends Element implements IEditorTextElement {
    public addedByUser!:boolean;
    public placeHolderTranslations?: { [key: string]: string };
    public preview_image: string = '';
    public preview_file: string = '';
    public tlf: string = '';
    public originalHeight!: number;
    public edited: boolean = false;
    public text: string = '';

    constructor(text: string, public rootStyle: IRootStyle = {} as any, public styles: any = {},
                public textEdits?: ITextEdits) {
        super();
        if (text && (!textEdits || textEdits.edited || !textEdits.canEdit)) {
            this.text = text;
        } else if (textEdits && textEdits.placeHolderTranslations) {
            this.setText(textEdits);
        } else {
            this.text = SF.Model.DefaultText['large'];
        }
        this.styles = styles || {};
    }

    public clone(): IEditorTextElement {
        const textElement = new TextElement(this.text, this.rootStyle, this.styles);
        this._clone(textElement);
        textElement.edited = this.edited;
        textElement.editable = this.editable;
        if (this.placeHolderTranslations) {
            textElement.placeHolderTranslations = this.placeHolderTranslations;
        }
        return textElement;
    }

    protected getCurrentLanguage(): string {
        return SF.currentLanguage;
    }

    protected setText(textEdits: ITextEdits): void {
        this.text = '';
        if (textEdits.placeHolderTranslations) {
            this.text = textEdits.placeHolderTranslations[this.getCurrentLanguage()];
            switch (textEdits.rootStyle.textTransform) {
                case 'uppercase':
                    this.text = this.text.toUpperCase();
                    break;
                case 'lowercase':
                    this.text = this.text.toLowerCase();
                    break;
                case 'capitalize':
                    this.text = this.text.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
                    break;
                case 'numeric':
                    this.text = this.text.replace(/[^\d]+/g, '');
                    break;
                default:
                    // Do Nothing...
            }
        }
    }
}

// an image element
class ImageElement extends Element implements IEditorImageElement {
    constructor(public image: IEditorImage) {
        super();
    }

    public clone(): ImageElement {
        const imageElement = new ImageElement(this.image);
        this._clone(imageElement);
        return imageElement;
    }
}

// create separate types for clipart and background
class ClipartElement extends ImageElement implements IEditorClipartElement {

    public clone(): ClipartElement {
        const imageElement = new ClipartElement(this.image);
        this._clone(imageElement);
        return imageElement;
    }
}

class GroupElement extends Element implements IEditorGroupElement {
    public _objects: any;
    public _canvas: any;
    public type: string;

    constructor(object: any, shapeObjects: any, canvas: any) {
        super();
        this.width = object.width;
        this.height = object.height;
        this.x = object.left;
        this.y = object.top;
        this._objects = shapeObjects;
        this._canvas = canvas;
        this.type = 'group';

    }
}

class FullPageElement extends ImageElement implements IEditorFullPageElement {
    constructor(public image: IEditorImage, public imagePosition: IEditorImagePosition, isDesignMode: boolean = false) {
        super(image);
        this.fixed = !isDesignMode;
    }

    public clone(): FullPageElement {
        const e = new FullPageElement(this.image, fabric.util.object.clone(this.imagePosition));
        this._clone(e);

        return e;
    }

    public getFrameWidth(): number {
        return this.width;
    }

    public getFrameHeight(): number {
        return this.height;
    }

    public getMarginLeft(): number {
        return 0;
    }

    public getMarginRight(): number {
        return 0;
    }

    public getMarginTop(): number {
        return 0;
    }

    public getMarginBottom(): number {
        return 0;
    }

    public replaceImage(image: IEditorImage): void {
        this.image = image;

        // set rotation from edits
        const rotation = image.edits && image.edits.rotation ? image.edits.rotation : 0;
        this.effects.initialRotation = rotation;
        this.effects.rotation = rotation;

        // re-place photo
        this.imagePosition = SF.Util.Translator.getElementImagePosition(this, true);
    }
}

export class BackgroundElement extends FullPageElement implements IEditorBackgroundElement {
    public onSpine!: boolean;

    public clone(): BackgroundElement {
        const backgroundElement = new BackgroundElement(this.image, fabric.util.object.clone(this.imagePosition));
        this._clone(backgroundElement);
        return backgroundElement;
    }

    public replaceImage(image: IEditorImage): void {
        this.image = image;

        // set rotation from edits
        const rotation = image.edits.rotation || 0;
        this.effects.initialRotation = rotation;
        this.effects.rotation = rotation;

        // re-place photo
        this.imagePosition = SF.Util.Translator.getElementImagePosition(this, true);
    }
}

class ForegroundElement extends FullPageElement implements IEditorForegroundElement {

    public clone(): ForegroundElement {
        const e = new ForegroundElement(this.image, fabric.util.object.clone(this.imagePosition));
        this._clone(e);

        return e;
    }

    public replaceImage(image: IEditorImage): void {
        this.image = image;

        // set rotation from edits
        const rotation = image.edits.rotation || 0;
        this.effects.initialRotation = rotation;
        this.effects.rotation = rotation;

        // re-place photo
        this.imagePosition = SF.Util.Translator.getElementImagePosition(this, true);
    }
}

// an image element that has a frame
class PhotoElement extends ImageElement implements IEditorPhotoElement {
    constructor(public image: IEditorImage, public imagePosition: IEditorImagePosition, public  frame: IEditorFrame) {
        super(image);
    }

    public clone(): PhotoElement {
        const e = new PhotoElement(this.image, fabric.util.object.clone(this.imagePosition), this.frame);
        this._clone(e);

        return e;
    }

    public getFrameWidth(): number {
        return this.width - this.getMarginLeft() - this.getMarginRight();
    }

    public getFrameHeight(): number {
        return this.height - this.getMarginTop() - this.getMarginBottom();
    }

    public getMarginLeft(): number {
        if (this.frame) {
            return this.width * (this.frame.marginLeft / 100);
        }

        if (this.effects && this.effects.borderSize) {
            return parseInt(this.effects.borderSize, 10);
        }

        return 0;
    }

    public getMarginRight(): number {
        if (this.frame) {
            return this.width * (this.frame.marginRight / 100);
        }

        if (this.effects && this.effects.borderSize) {
            return parseInt(this.effects.borderSize, 10);
        }

        return 0;
    }

    public getMarginTop(): number {
        if (this.frame) {
            return this.height * (this.frame.marginTop / 100);
        }

        if (this.effects && this.effects.borderSize) {
            return parseInt(this.effects.borderSize, 10);
        }

        return 0;
    }

    public getMarginBottom(): number {
        if (this.frame) {
            return this.height * (this.frame.marginBottom / 100);
        }

        if (this.effects && this.effects.borderSize) {
            return parseInt(this.effects.borderSize, 10);
        }

        return 0;
    }

    public replaceImage(image: IEditorImage, effectsRotation: number = 0): void {
        this.image = image;
        // set rotation from edits
        const rotation = image.edits.rotation || 0;
        this.effects.initialRotation = rotation;
        this.effects.rotation = effectsRotation || rotation;

        // re-place photo
        this.imagePosition = SF.Util.Translator.getElementImagePosition(this, true);

    }
}

export const PageTypes = {
    PAGE: 'page',
    FRONT_COVER: 'front_cover',
    BACK_COVER: 'back_cover',
    SPINE: 'spine',
    FRONT_FLY: 'front_fly',
    BACK_FLY: 'back_fly',
    EMPTY_PAGE: 'empty' // USED only for the 3D Preview, do not set a page type to be this otherwise...
};

class Observable implements IEditorObservable {
    private _eventListeners?: { [key: string]: any[] };

    public trigger(eventName: string, options?: any): IEditorObservable {
        if (this._eventListeners) {

            const listenersForEvent = this._eventListeners[eventName];
            if (listenersForEvent) {

                for (let i = 0, len = listenersForEvent.length; i < len; i++) {
                    // avoiding try/catch for perf. reasons
                    listenersForEvent[i].call(this, options || {});
                }
            }
        }
        return this as IEditorObservable;
    }

    public on(eventName: string | any, handler: (options: any) => void): IEditorObservable {
        if (!this._eventListeners) {
            this._eventListeners = {};
        }

        // one object with key/value pairs was passed
        if (arguments.length === 1) {
            for (const prop in eventName) {
                if (eventName.hasOwnProperty(prop)) {
                    this.on(prop, eventName[prop]);
                }
            }
        } else {
            if (!this._eventListeners[eventName]) {
                this._eventListeners[eventName] = [];
            }

            this._eventListeners[eventName].push(handler);
        }

        return this;
    }

    public off(eventName: string | any, handler: (options: any) => void): IEditorObservable {
        if (this._eventListeners) {
            // remove all key/value pairs (event name -> event handler)
            if (arguments.length === 0) {
                this._eventListeners = {};
            } else if (arguments.length === 1 && typeof arguments[0] === 'object') { // one object with key/value pairs was passed
                for (const prop in eventName) {
                    if (eventName.hasOwnProperty(prop)) {
                        this._removeEventListener(prop, eventName[prop]);
                    }
                }
            } else {
                this._removeEventListener(eventName, handler);
            }
        }
        return this;
    }

    private _removeEventListener(eventName: string, handler: (options: any) => void): void {
        if (!this._eventListeners || !this._eventListeners[eventName]) {
            return;
        }

        if (handler) {
            fabric.util.removeFromArray(this._eventListeners[eventName], handler);
        } else {
            this._eventListeners[eventName].length = 0;
        }
    }
}

// the primary edits object that holds everything
class Page extends Observable implements IEditorPage {
    public id: null | number;
    public type: string;
    public number: number = 0;
    public label: string = '';
    public pagerLabel: string = '';
    public width: number = 0;
    public height: number = 0;
    // noinspection JSMismatchedCollectionQueryUpdate
    public elements: IEditorElement[] = [];
    public mode: string = 'facing';
    public name: string = '';
    public index: number = 0;
    public caption: string = '';
    public groupIndex: number = 0;
    public canEdit: boolean = true;
    public canReorder: boolean = true;
    public canDelete: boolean = true;
    public joined: boolean = true;
    public spanning: boolean = true;
    public isPreviewPage: boolean = false;
    // noinspection JSMismatchedCollectionQueryUpdate
    public errors: IEditorElementError[] = [];
    public bleed: any = null;
    public duplicateId: number | null = null;
    public isInsideFrontCover: boolean = false;
    public isInsideBackCover: boolean = false;
    public preview: string | HTMLCanvasElement | null;
    public isLetterBoxed: boolean = false;
    public productType: string = '';

    constructor() {
        super();
        this.id = null;
        this.type = PageTypes.PAGE;
        // store a canvas for the pager
        this.preview = null;
    }

    public isPortrait(): boolean {
        return this.height > this.width;
    }

    public isDuplicate(): boolean {
        return this.duplicateId !== null;
    }

    public hasForeground(): boolean {
        return !!this.getForeground();
    }

    public setPreview(preview: HTMLCanvasElement, previewChangeParameters: { selfQueue: object[]; noPageScroll: boolean }): void {
        this.preview = preview;
        this.trigger(SF.Model.previewChangeEvent, {
            selfQueue: previewChangeParameters.selfQueue,
            noPageScroll: previewChangeParameters.noPageScroll
        });
    }

    public setErrors(errors: any): void {
        this.errors = errors;
        this.trigger(SF.Model.errorsChangeEvent);
    }

    public getPreviewImageAsBase64(outputFormat:string): string {
        if (!this.preview || typeof (this.preview as HTMLCanvasElement).toDataURL !== 'function') {
            return '';
        }
        let mimeOutputFormat;
        switch (outputFormat) {
            case 'png':
                mimeOutputFormat = 'image/png';
                break;
            case 'webp':
                mimeOutputFormat = 'image/webp';
                break;
            case 'jpg':
            case 'jpeg':
            default:
                mimeOutputFormat = 'image/jpeg';
                break;
        }

        return (this.preview as HTMLCanvasElement).toDataURL(mimeOutputFormat);
    }

    public getLabel(forPager: boolean = false, project?: IEditorProject): string {
        if (forPager) {
            const pageNames = project && project.pageNames.length > 0 ? project.pageNames : undefined;
            return SF.Util.Edits.getLabel(this.type, this.number, pageNames, forPager);
        } else {
            return this.label;
        }
    }

    public getCaption(): string {
        return this.caption;
    }

    public getBackground(): IEditorBackgroundElement | null {
        const matches = this.elements.filter(function (element: IEditorElement): boolean {
            return element instanceof SF.Model.BackgroundElement;
        });

        return matches.length >= 1 ? matches[0] as IEditorBackgroundElement : null;
    }

    public getForeground(): IEditorForegroundElement | null {
        const matches = this.elements.filter(function (element: IEditorElement): boolean {
            return element instanceof SF.Model.ForegroundElement;
        });

        return matches.length >= 1 ? matches[0] as IEditorBackgroundElement : null;
    }

    public getPhotoIdsWithCount(photos: { [id: number]: number }): { [id: number]: number } {
        photos = photos || {};

        for (let i = 0; i < this.elements.length; i++) {
            const el = this.elements[i];

            const imageEl = el as IEditorImageElement;
            if ((el instanceof SF.Model.PhotoElement || el instanceof SF.Model.BackgroundElement) &&
                imageEl.image && imageEl.image.id && !(imageEl.image instanceof SF.Model.GraphicAsset)) {
                photos[imageEl.image.id as number] = (photos.hasOwnProperty(imageEl.image.id as any) ? photos[imageEl.image.id as number] : 0) + 1;
            }
        }

        return photos;
    }

    public emptyClone(): IEditorPage {
        const page = new Page();

        ['id', 'type', 'width', 'height', 'number', 'mode', 'name', 'index', 'groupIndex', 'canEdit',
            'canReorder', 'canDelete', 'joined', 'spanning', 'isPreviewPage', 'bleed', 'caption'].forEach((prop: string): void => {
            (page as any)[prop] = (this as any)[prop];
        });

        return page;
    }
}

class PageGroup extends Observable implements IEditorPageGroup {

    public index: number;
    public type: string = 'page-group';
    public pages: IEditorPage[] = [];

    constructor(pages?: IEditorPage[]) {
        super();
        this.setPages(pages || []);
        this.index = 0;
    }

    public addPage(page: IEditorPage): void {
        this.pages.push(page);
    }

    public setPages(pages: IEditorPage[]): void {
        this.pages = pages;
    }

    public pagesJoined(value?: boolean): boolean {
        if (value !== undefined) {
            this._setBoolean('joined', value);
        }

        return this._getBoolean('joined');
    }

    public pagesSpanning(value?: boolean): boolean {
        if (value !== undefined) {
            this._setBoolean('spanning', value);
        }

        return this._getBoolean('joined') && this._getBoolean('spanning');
    }

    public canDelete(): boolean {
        return this._getBoolean('canDelete');
    }

    public canEdit(): boolean {
        return this._getBoolean('canEdit');
    }

    public canReorder(): boolean {
        return this._getBoolean('canReorder');
    }

    public getLastPage(): IEditorPage {
        return this.pages[this.pages.length - 1];
    }

    public getObjects(): IEditorShape[] {
        throw new Error('getObjects is not implemented');
    }

    public _setBoolean(prop: string, value: boolean): void {
        this.pages.forEach(function (page: IEditorPage): void {
            (page as any)[prop] = value;
        });

        this.trigger('change');
    }

    public _getBoolean(prop: string): boolean {
        return this.pages
            .map(function (page: any): any {
                return page[prop];
            })
            .reduce(function (previousValue: any, currentValue: any): boolean {
                return previousValue && currentValue;
            });
    }
}

// Project Model
class Project implements IEditorProject {

    public id: number|null;
    public name: string = '';
    public productType: string|null;
    public schemaName: string|null;
    public classification: string|null;
    public productSchemaName: string = '';
    public productName: string|null;
    public editorType: string|null;
    public cartItemId: number|null;
    public productId: number|null;
    public productTypeId: number|null;
    public photobookId: number|null;
    public themeId: number = 0;
    public photoId: number|null;
    public productDesignId: number|null;
    public selectedPageIndex: number;
    public selectedGroupIndex: number;
    public previewUrl: string|null;
    public groupSize: number;
    // noinspection JSMismatchedCollectionQueryUpdate
    public groups: any[];
    public pages: IEditorPage[];
    public visiblePages: IEditorPage[] = [];
    public photos: IEditorProjectPhotos|null;
    public settings!: IEditorSettings;
    public product!: IEditorProduct;
    public previewData: { [key: string]: IPreviewThumb[] }|null;
    public width: number = 0;
    public height: number = 0;
    public hasSelectableAttributes: boolean;
    public hasSelectableWrapStyle: boolean;
    public errorConfiguration: { zoomWarning: number, zoomError: number };
    public pageNames: string[] = [];
    private errors: any;
    public keyhole: {
        keyholePositionLeft: number,
        keyholePositionTop: number,
        keyholeSizeHeight: number,
        keyholeSizeWidth: number,
        keyholeSvgString: string
    }|undefined = undefined;
    public hasKeyhole: boolean = false;
    public overlayPreview: EditorMaskOverlay|null = null;
    public maskBW: EditorMaskOverlay|null = null;
    public maskMerge: {[key:string]:MaskOverlayImage}|null = null;
    public nonPrintableBackground: EditorNonPrintableBackground|null = null;
    public hasOverlayPreview: boolean = false;
    public hasNonPrintableBackground: boolean = false;
    public hasUndo!: boolean;
    public hasRedo!: boolean;
    public hasCoverPageBleed: boolean = false;

    constructor() {
        this.id = null;
        this.productType = null;
        this.schemaName = null;
        this.classification = null;
        this.productName = null;
        this.editorType = null;
        this.cartItemId = null;
        this.productId = null;
        this.productTypeId = null;
        this.photobookId = null;
        this.photoId = null;
        this.productDesignId = null;
        this.selectedPageIndex = 0;
        this.selectedGroupIndex = 0;
        this.previewUrl = null;
        this.groupSize = 2;
        this.groups = [];
        this.pages = [];
        this.photos = null;
        this.errors = null;
        this.previewData = null;
        this.hasSelectableAttributes = false;
        this.hasSelectableWrapStyle = false;
        this.errorConfiguration = {
            zoomWarning: 2,
            zoomError: 3
        };
    }

    public initializePages(pages: IEditorPage[]): void {
        // set the group size
        this.groupSize = this._getGroupSize();

        // sort the pages
        this._sortPages(pages);

        // set pages
        this.pages = pages;

        // set the groups
        this.groups = this._groupPages();

        // mark the preview page
        this.pages.forEach((page: IEditorPage) => {
            // We want the preview for the front page of the calendar but not for the front page of photo books
            // (might be good enough to do page.canEdit).
            page.isPreviewPage = (page.canEdit && (page.type == PageTypes.PAGE || (this.productType === SF.Model.ProductType.ED_12P_CALENDAR && page.type === PageTypes.FRONT_COVER)));
        });

    }

    public initializeErrors(): void {
        this.pages.forEach((page: IEditorPage): void => {
            page.errors = globalImports.SF.Util.ErrorDetector.getErrorsInPage(page, this.pages.length, this.errorConfiguration);
        });
        this.checkErrorsOnSpine();
    }

    private checkErrorsOnSpine(): void {
        const backCover = this._getPageByType(this.pages, PageTypes.BACK_COVER);
        const frontCover = this._getPageByType(this.pages, PageTypes.FRONT_COVER);
        if (!frontCover || !backCover) {
            return;
        }
        this.pages.forEach((page: IEditorPage) => {
            if (page.type === PageTypes.SPINE && page.width === 0 && page.errors.length > 0) {
                backCover.errors.push(...page.errors);
                frontCover.errors.push(...page.errors);
                page.errors = [];
            }
        });
    }

    public checkPageErrors(): void {
        this.pages.forEach((page: IEditorPage) => {
            page.setErrors(SF.Util.ErrorDetector.getErrorsInPage(page, this.pages.length, this.errorConfiguration));
        });
        this.checkErrorsOnSpine();
    }

    public getUniquePages(): IEditorPage[] {
        const uniquePages: IEditorPage[] = [];
        const coverTypes: string[] = [SF.Model.PageTypes.BACK_COVER, SF.Model.PageTypes.SPINE, SF.Model.PageTypes.FRONT_COVER];
        if (this.hasCoverPage()) {
            for (let i = 0; i < coverTypes.length; i ++) {
                const cover = this.getUniqueCoverPage(coverTypes[i]);
                if (cover) {
                    const uniqueCoverPage = this.getUniqueCoverPage(coverTypes[i]);
                    if (uniqueCoverPage) {
                        uniquePages.push(uniqueCoverPage);
                    }
                }
            }
        }
        const nonCoverPages = this.pages.filter((value: IEditorPage, index: number, arr: IEditorPage[]): boolean => {
            return arr.indexOf(value) === index && coverTypes.indexOf(value.type) < 0;
        });
        uniquePages.push(...nonCoverPages);
        return uniquePages;
    }

    private hasCoverPage(): boolean {
        const foundCoverPage =  this.pages.find((page: IEditorPage) => {
            return page.type === SF.Model.PageTypes.BACK_COVER || page.type === SF.Model.PageTypes.SPINE || page.type === SF.Model.PageTypes.FRONT_COVER;
        });

        return !!foundCoverPage;

    }

    public getUniqueCoverPage(coverPageType: string): IEditorPage|undefined {
        return this.pages.find((page: IEditorPage) => {
            return page.type === coverPageType;
        });
    }

    public getErrors(): IEditorElementError[] {
        return this.pages
            .map(function (p: IEditorPage): IEditorElementError[] {
                return p.errors;
            })
            .reduce(function (a: IEditorElementError[], b: IEditorElementError[]): IEditorElementError[] {
                return a.concat(b);
            });
    }

    public getBillablePages(): number {
        if (this.productType === ProductType.ED_PHOTO_BOOK || this.productType === ProductType.ED_FLIP_BOOK) {
            return this.pages.filter(function (page: IEditorPage): boolean {
                return page.canDelete || page.canEdit;
            }).length;
        }

        return this.pages.length;
    }

    public getRemovablePages(): number {
        if (this.productType === ProductType.ED_PHOTO_BOOK || this.productType === ProductType.ED_FLIP_BOOK || this.productType === ProductType.ED_12P_CALENDAR) {
            return this.pages.filter(function (page: IEditorPage): boolean {
                return page.type == 'page';
            }).length;
        }

        return this.pages.length;
    }

    private _getGroupSize(): number {
        // prioritize type over subtype
        if (this.productType == ProductType.ED_PHOTO_BOOK || this.productType == ProductType.ED_FLIP_BOOK || this.editorType === EditorType.ES_FACING_PAGES) {
            return 2;
        }
        return 1;
    }

    private _sortPages(pages: IEditorPage[]): void {
        pages.sort(function (a: IEditorPage, b: IEditorPage): number {
            switch (a.type) {
                // back cover is always the first page
                case PageTypes.BACK_COVER:
                    return -1;

                // spine is the second page (after the cover)
                case PageTypes.SPINE:
                    if (b.type === PageTypes.BACK_COVER) {
                        return 1;
                    }

                    return -1;

                // front cover is after the spine
                case PageTypes.FRONT_COVER:
                    if (a.type === PageTypes.BACK_COVER || b.type === PageTypes.SPINE) {
                        return 1;
                    }

                    return -1;

                // front fly is after the front cover, and behind everything else
                case PageTypes.FRONT_FLY:
                    if (b.type === PageTypes.FRONT_COVER || b.type === PageTypes.SPINE || b.type === PageTypes.BACK_COVER) {
                        return 1;
                    } else if (b.type === PageTypes.FRONT_FLY) {
                        return 0;
                    }

                    return -1;

                // pages are in front of back cover, and behind everything else
                case PageTypes.PAGE:
                    if (b.type == PageTypes.PAGE) {
                        if (a.number < b.number) {
                            return -1;
                        } else if (a.number > b.number) {
                            return 1;
                        }

                        return 0;
                    } else if (b.type === PageTypes.BACK_FLY) {
                        return -1;
                    }

                    return 1;

                case PageTypes.BACK_FLY:
                    if (b.type === PageTypes.BACK_FLY) {
                        return 0;
                    }

                    return 1;

                default:
                    // should never get here
                    console.warn('Invalid page type: ' + a.type);
                    return 0;
            }

        });
    }

    private _groupPages(): IEditorPageGroup[] {
        const groups:IEditorPageGroup[] = [];

        // first, we deal with any cover pages
        let insideFrontCoverFound = false;
        const coverGroup = this._getCoverGroup();

        if (coverGroup) {
            groups.push(coverGroup);
        }

        // group the rest of the pages
        let page;
        let group = new PageGroup();
        group.index = groups.length;
        let currentGroupSize = 0;

        for (let i = 0; i < this.pages.length; i++) {
            page = this.pages[i];

            // this is a simple group function, skip any cover details
            if ([PageTypes.BACK_COVER, PageTypes.SPINE, PageTypes.FRONT_COVER].indexOf(page.type) >= 0) {
                continue;
            }

            // mark the inside front cover
            if (!insideFrontCoverFound && page.type === PageTypes.FRONT_FLY) {
                page.isInsideFrontCover = true;
                insideFrontCoverFound = true;
            }

            // if current group is full, create a new one
            if (currentGroupSize === this.groupSize) {
                // add group to array of groups
                groups.push(group);

                // reset data
                group = new PageGroup();
                group.index = groups.length;
                currentGroupSize = 0;
            }

            // set page index
            page.index = i;
            page.groupIndex = group.index;

            // increment groupSize first
            currentGroupSize++;

            group.addPage(page);
        }

        // if the last page is a fly page, mark it as inside cover
        if (page && page.type === PageTypes.BACK_FLY) {
            page.isInsideBackCover = true;
        }

        if (group.pages.length > 0) {
            groups.push(group);
        }

        return groups as IEditorPageGroup[];
    }

    private _getCoverGroup(): IEditorPageGroup|null {
        let group:IEditorPageGroup|null = null;
        const backCover = this._getPageByType(this.pages, PageTypes.BACK_COVER);
        const frontCover = this._getPageByType(this.pages, PageTypes.FRONT_COVER);

        if (backCover && frontCover) {
            // init group
            group = new PageGroup();

            // get spine and back cover
            const spine = this._getPageByType(this.pages, PageTypes.SPINE);

            // add the pages
            group.addPage(backCover);
            if (spine) {
                group.addPage(spine);
                spine.index = 1;
            }
            group.addPage(frontCover);

            // set appropriate indices for the pages
            backCover.index = 0;
            frontCover.index = 2;
        } else if (frontCover) {
            // init group
            group = new PageGroup();

            group.addPage(frontCover);
            frontCover.index = 0;
        }

        return group;
    }

    private _getPageByType(pages: IEditorPage[], type: string): IEditorPage|null {
        let page;

        for (let i = 0; i < pages.length; i++) {
            page = pages[i];

            if (page.type === type) {
                return page;
            }
        }

        return null;
    }

    public _resetPhotoUsage(): void {
        const usage = {};

        for (let i = 0; i < this.pages.length; i++) {
            this.pages[i].getPhotoIdsWithCount(usage);
        }
        if (this.photos) {
            this.photos.resetUsage(usage);
        }
    }

}

export class EditorSettings implements IEditorSettings {

    protected readonly settings: any;

    constructor(settings: any, designMode: boolean) {
        this.settings = globalImports.fabric.util.object.extend(settings, {design_mode: designMode});
    }

    public designMode(): boolean {
        return this.settings.designMode;
    }

    public setTemplateHasNoPhotos(value:boolean):void {
        this.settings.templateHasNoPhotos = value;
    }

    public getTemplateHasNoPhotos():boolean {
        return this.settings.templateHasNoPhotos;
    }

    public isPagerZoomSliderVisible(): boolean {
        return !!this.settings.pager_zoom_slider;
    }

    public getPagerInitialState(): boolean {
        return this.settings.pager_initial_state;
    }

    public isPagerNavigationVisible(): boolean {
        return !!this.settings.pager_navigation_buttons;
    }

    public isPagerViewModesVisible(): boolean {
        return !!this.settings.pager_view_buttons;
    }

    public threeDPreviewOption(): ThreeDOption {
        return this.settings.threed_preview_option as ThreeDOption;
    }

}

/**
 * This class tracks the usage of photos across a project. Each photo is stored as a tuple {primaryId, secondaryId, count}.
 *
 * The primaryId is the id of the photo in the user's gallery, and once the project is saved, it will also have a
 * secondaryId in case the user deletes the photo from the gallery.
 *
 * The removed vector will always be empty from the server, it is only used to pass data regarding deletions to
 * the back end.
 *
 * @param used
 * @param removed
 * @returns {{used: (*|Array), removed: (*|Array), addPhoto: addPhoto, removePhoto: removePhoto, resetUsage: resetUsage}}
 * @constructor
 */
const ProjectPhotos: any = function (used: any[] = [], removed: any[] = []): any {
    used = adjustForCount(used);

    // constants for indices
    const PRIMARY_ID = 0;
    const SECONDARY_ID = 1;
    const USAGE_COUNT = 2;

    return {
        used: used,
        removed: removed,
        addPhoto: addPhoto,
        removePhoto: removePhoto,
        resetUsage: resetUsage,
        getCount: getCount,
        getIndexedCount: getIndexedCount
    };

    ////////////////
    // PUBLIC API //
    ////////////////
    function addPhoto(id: string, count: number): void {
        count = count || 1;

        // is the photo already used?
        const node = findNodeInArray(used, id);
        if (node) {
            // increment count
            node[USAGE_COUNT] += count;
        } else {
            // add photo to used array with the count
            used.push([id, 0, count]);
        }

        // remove the array from removed array if it exists in there
        removeFromArray(removed, id);
    }

    function removePhoto(id: string): void {
        // if the photo is actually being used
        const node = findNodeInArray(used, id);

        if (node) {
            // if the usage count is greater than 1, just decrement and return
            if (node[USAGE_COUNT] > 1) {
                node[USAGE_COUNT]--;
                return;
            }

            // add to removed photo vector
            if (node[SECONDARY_ID] !== 0) {
                removed.push(node);
            }

            // remove from used photo vector
            used.splice(used.indexOf(node), 1);
        }
    }

    function getCount(id: string): number {
        const node = findNodeInArray(used, id);
        return node ? node[USAGE_COUNT] : 0;
    }

    /**
     * 'usage' is a collection of k => pairs where the k is the photoId, and v indicates how many times its used
     *
     * @param usage
     */
    function resetUsage(usage: { [key: string]: number }): void {
        if (!usage) {
            return;
        }

        let id: any;
        let node: any[];

        // first, any photo's in our removed vector that's in the usage object needs to be sliced
        for (let i = 0; i < removed.length; i++) {
            node = removed[i];
            id = node[PRIMARY_ID];

            if (usage.hasOwnProperty(id)) {
                // calling internal API as this photo only belongs in removed, and no other work is required
                removeFromArray(removed, id);
            }
        }

        //used Array is modified in remove photo. lets loop through a clone
        const usedCopy = used.slice();

        // second, any photo's in our used vector that's not in the usage object needs to be marked removed
        for (let i = 0; i < usedCopy.length; i++) {
            node = usedCopy[i];
            id = node[PRIMARY_ID];

            //node[USAGE_COUNT] is modified in removePhoto. set usage count before looping
            const usageCount = node[USAGE_COUNT];
            // normally we would just splice this from used, but we also need to mark it removed
            for (let j = 0; j < usageCount; j++) {
                removePhoto(id);
            }
        }

        // now, any new photo's need to be added
        for (const photoId in usage) {
            if (usage.hasOwnProperty(photoId)) {
                addPhoto(parseInt(photoId, 10) as any, usage[photoId]);
            }
        }
    }

    // UTILITY FUNCTIONS
    function getIndexedCount(): { [key:number] : number } {
        const hash: { [key:number] : number } = {};

        for (let i = 0; i < used.length; i++) {
            const node = used[i];
            hash[node[PRIMARY_ID]] = node[USAGE_COUNT];
        }

        return hash;
    }

    ///////////////////////
    // PRIVATE FUNCTIONS //
    ///////////////////////
    function findNodeInArray(array: any[], id: string): any[] {
        const index = findInArray(array, id);
        return index >= 0 ? array[index] : null;
    }

    function findInArray(array: any[], id: any): number {
        for (let i = 0; i < array.length; i++) {
            if (array[i][PRIMARY_ID] == id) {
                return i;
            }
        }

        return -1;
    }

    function removeFromArray(array: any[], id: any): void {
        const index = findInArray(array, id);

        if (index >= 0) {
            array.splice(index, 1);
        }
    }

    function adjustForCount(array: any[]): any[] {
        array = cleanData(array);

        for (let i = 0; i < array.length; i++) {
            const node = array[i];

            if (node.length === 2) {
                node[USAGE_COUNT] = 1;
            }
        }

        return array;
    }

    function cleanData(array: any[]): any[] {
        return array.map(function (node: any[]): any[] {
            return node.map(function (entry: any): any {
                return parseInt(entry, 10);
            });
        });
    }
};

const Product: any = function (id: string, price: number, attributes: { [key: string]: string }, pageNames:string[]|undefined): any {
    // deal with edge cases in data
    if (attributes.hasOwnProperty(ProductAttribute.WRAP_OPTIONS) && attributes[ProductAttribute.WRAP_OPTIONS]) {
        attributes[ProductAttribute.WRAP_OPTIONS] = JSON.parse(attributes[ProductAttribute.WRAP_OPTIONS]);
    }

    function getAttr(attr: string, defaultValue: any): string {
        return attributes.hasOwnProperty(attr) ? attributes[attr] : (defaultValue === undefined ? null : defaultValue);
    }

    function getInt(attr: string, defaultValue: number): number {
        return parseInt(getAttr(attr, defaultValue || 0), 10);
    }

    return {
        // public properties
        id,
        price,
        attributes,
        pageNames,

        // functions
        getAttr: getAttr,
        getInt: getInt
    };
};

export class Font implements IEditorFont {
    public openedFont: IEditorOpenedFont = {
        b: null,
        i: null,
        bi: null,
        r: null
    };
    public name: string;
    // noinspection JSMismatchedCollectionQueryUpdate
    public styles: string[];
    public public: boolean;

    constructor(private fontData: IFontData) {
        // public properties
        this.name = fontData.name;
        this.styles = fontData.styles;
        this.public = fontData.public;
    }

    // getters
    public getImage(): string {
        return this.fontData.image;
    }

    public getCSS(): string {
        return this.fontData.css;
    }

    public getTTF(style: string): string {
        return (this.fontData.faces as any)[style];
    }

    public canItalicize(isBold: boolean): boolean {
        return isBold ? this.hasStyle('bi') : this.hasStyle('i');
    }

    public canBold(isItalic: boolean): boolean {
        return isItalic ? this.hasStyle('bi') : this.hasStyle('b');
    }

    public hasStyle(style: string): boolean {
        return this.fontData.faces.hasOwnProperty(style);
    }

}

const SF = globalImports.SF || (globalImports.SF = {});

SF.Util = SF.Util || globalImports.SF.Util;

if (!SF.tr) {
    if (typeof window !== 'undefined' && (window as any).tr) {
        SF.tr = (window as any).tr;
    } else {
        if (!fabric.isLikelyNode) {
            console.error('window.tr does not exist - bad javascript loading error');
        }
        // noinspection JSUnusedLocalSymbols
        SF.tr = function (phraseKey: string, replacements?: Object | string, defaultTranslation?: string | boolean,
                          enableTranslationWrapper?: boolean, encodeBreakAsHtml?: boolean, doNotLogIfMissing?: boolean): any {
            return defaultTranslation;
        };
    }
}

export interface IDefaultText {
    large: string;
    medium: string;
    small: string;
    old_default: string;
}

export const DefaultText: IDefaultText = {
    large: '',
    medium: '',
    small: '',
    old_default: ''
}

// @ts-ignore
// @ts-ignore
SF.Model = {
    // project related
    Project: Project,
    EditorSettings: EditorSettings,
    ProjectPhotos: ProjectPhotos,
    PageTypes: PageTypes,
    Page: Page,
    previewChangeEvent: 'previewChange',
    errorsChangeEvent: 'errorsChange',

    PageGroup: PageGroup,

    // image related
    ThumbSize: ThumbSize,
    Thumb: Thumb,
    Image: Image,
    Photo: Photo,
    GraphicAsset: GraphicAsset,
    Edge: Edge,

    // Shape
    ShapeAsset: ShapeAsset,
    ShapeAssetTypes: ShapeAssetTypes,

    // others
    Layout: Layout,
    Template: Template,
    Product: Product,
    Masks: Masks,
    Font: Font,

    // edits related
    Element: Element,
    TextElement: TextElement,
    DefaultText: {
        large: '',
        medium: '',
        small: '',
        old_default: ''
    },
    ImageElement: ImageElement,
    ClipartElement: ClipartElement,
    GroupElement: GroupElement,
    BackgroundElement: BackgroundElement,
    ForegroundElement: ForegroundElement,
    FullpageElement: FullPageElement,
    // @ts-ignore
    PhotoElement: PhotoElement,
    ElementCollection: ElementCollection,

    // constants
    ViewMode: ViewMode,
    ViewState: ViewState,
    ToolbarSize: ToolbarSize,
    HandleLayout: HandleLayout,
    ProductType: ProductType,
    TemplatedProductTypes: TemplatedProductTypes,
    EditorType: EditorType,
    ElementErrorType: ElementErrorType,
    THREED_PREVIEW_COLOR: THREED_PREVIEW_COLOR,
    ProductAttribute: ProductAttribute,
    EditorBleedProperties: EditorBleedProperties,
    CoverPhotoMarginAttribute: CoverPhotoMarginAttribute,
    Commands: Commands,
    WrapOptions: EditorWrapOptions,
    EdgeStyles: EdgeStyles,
    CornerTypes: CornerTypes,
    GalleryPanels: GalleryPanels,
    // products that can replace background without a dialog
    ReplaceBackgroundsForProduct: [
        ProductType.ED_FLIP_BOOK,
        ProductType.ED_PRINT,
        ProductType.ED_CANVAS_EDITOR,
        ProductType.ED_CANVAS,
        ProductType.ED_PHOTO_GIFT,
        ProductType.ED_PASSPORT_PHOTO
    ]
};

if (!globalImports.SF.Model) {
    globalImports.SF.Model = SF.Model;
}
if (!globalImports.SF.Util) {
    globalImports.SF.Util = SF.Util;
}
function loadDefaultText():void {
    SF.Model.DefaultText = {
        large: SF.tr('PERSONALIZE_THIS_SPACE_WITH_YOUR_VERY_OWN_MESSAGE', {}, 'Personalize this space with your very own message'),
        medium: SF.tr('PERSONALIZE_THIS_SPACE', {}, 'Personalize this space'),
        small: SF.tr('PERSONALIZE', {}, 'Personalize'),
        old_default: SF.tr('YOUR_TEXT_HERE', {}, 'Your Text Here')
    };

}

// If this page is loaded before translations then DefaultText is going to be wrong...  This is relying on order
// of included JavaScript that has changed in the newDesign...
if (fabric.isLikelyNode) {
    loadDefaultText();
} else {
    if (document.readyState != 'loading') {
        loadDefaultText();
    } else {
        document.addEventListener('DOMContentLoaded', loadDefaultText);
    }
}
